<template>
  <el-dialog
      :model-value="props.visible"
      title="计算器"
      width="370"
      top="6vh"
      destroy-on-close
      draggable
      :modal="false"
      modal-class="calc-pop-2134a"
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >

      <div style="height: 500px;overflow-y: hidden;flex-direction: column-reverse;">
          <iframe
              id="myCalcRef"
              style="overflow-y: hidden;width: 100%;height: 100%;margin-top: -36px;"
              :src="getPageSrc()"
              frameborder="0"></iframe>
      </div>

  </el-dialog>
</template>

<script setup>
const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
})


function onOpen() {
    const iframe = document.getElementById('myCalcRef');
    iframe.onload = ()   => {
        iframe.contentWindow.focus(); // 获取焦点
    };
}

function getPageSrc() {
  /*let host = ''
  if (location.host.indexOf('localhost') > -1) {
    host = 'https://wwwpre.rhkj.com'//'http://localhost:3001'
  }  else {
    host = 'https://' + location.host111
  }
  return `${host}/web/baseCalculator`*/
    return `https://static.rhkj.com/renhe_fe/other/calc/index.html?hideToggle=1&type=win10`
}


const emit = defineEmits(['update:visible', 'refresh'])

function closedModal() {
  emit('update:visible', false)
}
</script>

<style lang="scss">
.calc-pop-2134a {
  pointer-events: none;

  .el-dialog {
    pointer-events: auto;
    padding-bottom: 0;
  }
}
</style>
